import { Directive, ElementRef, Input, OnInit, Renderer2 } from "@angular/core";
import { PrimaryButton } from "../../models/primary-button.models";

@Directive({
  selector: "button[primary-button]",
})
export class PrimaryButtonDirective implements OnInit {
  @Input("primary-button") primaryButton!: PrimaryButton;
  constructor(private element: ElementRef<HTMLElement>, private render: Renderer2) {}

  ngOnInit() {
    const element = this.element.nativeElement;
    this.render.setAttribute(element, "primary-button", this.primaryButton);
  }
}
